import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import styles from './LoginPage.module.css';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Trim whitespace from email
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setError('Email is required');
      return;
    }
    if (!password) {
      setError('Password is required');
      return;
    }

    setIsLoading(true);

    try {
      await login(trimmedEmail, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Remove any invisible characters and normalize
    const value = e.target.value.replace(/[\u200B-\u200D\uFEFF]/g, '');
    setEmail(value);
  };

  return (
    <div className={styles.container}>
      {/* Background orbs for liquid glass effect */}
      <div className={styles.backgroundOrb} />
      <div className={styles.backgroundOrb2} />

      {/* Logo */}
      <div className={styles.logo}>
        <img
          src="/cap8-logo-mark-full-color-rgb.png"
          alt="Cap8 Logo"
          className={styles.logoImage}
        />
        <span className={styles.logoText}>Market Commentary</span>
      </div>

      {/* Login Card */}
      <div className={styles.card}>
        <div className={styles.header}>
          <h2>Welcome back</h2>
          <p>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.formGroup}>
            <label htmlFor="email" className={styles.formLabel}>
              Email
            </label>
            <input
              type="text"
              inputMode="email"
              id="email"
              className={styles.formInput}
              value={email}
              onChange={handleEmailChange}
              placeholder="Enter your email"
              autoComplete="email"
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.formLabel}>
              Password
            </label>
            <input
              type="password"
              id="password"
              className={styles.formInput}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className={styles.spinner} />
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>

      <div className={styles.footer}>
        Powered by Cap8
      </div>
    </div>
  );
}
